import axios from '@_system/axios/axios.js'
export default {
	path: '/purchase',
	list(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	save(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	updateSuggest(data = {}) {
		return new Promise((resolve, reject) => {
			axios.put(this.path + '/suggest', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	init(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get('moduleConfig/admin/purchase.purchase', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	goodsimport(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/goodsimport/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getPurchaseGoods(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getPurchaseGoods', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	uploadwln(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/uploadwln', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	checkotherinventory(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/checkotherinventory', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},


	listpolicy(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/listpolicy', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	buildIntelPchsAdvise(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/buildIntelPchsAdvise', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getLongTask(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getLongTask', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	queryIntelligencePchs(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/queryIntelligencePchs', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	clearPolicyCache(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/clearPolicyCache', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	computebestunit(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/computebestunit', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},

	saveTransferBill(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/saveTransferBill', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	checkInventoryGoods(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/checkInventoryGoods', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},

	getStock(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getStock', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	
	createpurchasegoods(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/createpurchasegoods', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	suppliergrouppurchase(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/suppliergrouppurchase', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},

	demo(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post('demo', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
}